module.exports = __webpack_public_path__ + "static/media/vizmuvek.4115ac6d.png";